import React from "react"

import {
  BalloonIcon,
  FieldSiteIcon,
  FieldSurveyIcon,
  MooredBuoyIcon,
  PermanentLandSiteIcon,
  PermanentWaterSiteIcon,
  VehicleIcon,
  ShipIcon,
  RocketIcon,
} from "../icons/static-platform-icons"

export const MOVING_PLATFORMS_COLORS = [
  "#b2df8a",
  "#33a02c",
  "#fdbf6f",
  "#ff7f00",
  "#a6cee3",
  "#1f78b4",
  "#fb9a99",
  "#e31a1c",
  "#cab2d6",
  "#6a3d9a",
  "#ffff99",
  "#b15928",
]

export const FALLBACK_COLOR = "#1a9b8c"

export const STATIC_PLATFORMS = [
  {
    name: "Permanent Land Site",
    color: "#FFFFD4",
    icon: <PermanentLandSiteIcon />,
    mapIcon: "PermanentLandSiteIcon",
  },
  {
    name: "Vehicle",
    color: "#FEE391",
    icon: <VehicleIcon />,
    mapIcon: "VehicleIcon",
  },
  {
    name: "Balloon Launch Site",
    color: "#FEC44F",
    icon: <BalloonIcon />,
    mapIcon: "BalloonIcon",
  },
  {
    name: "Field Site",
    color: "#FE9929",
    icon: <FieldSiteIcon />,
    mapIcon: "FieldSiteIcon",
  },
  {
    name: "Field Survey",
    color: "#EC7014",
    icon: <FieldSurveyIcon />,
    mapIcon: "FieldSurveyIcon",
  },
  {
    name: "Permanent Water Site",
    color: "#CC4C02",
    icon: <PermanentWaterSiteIcon />,
    mapIcon: "PermanentWaterIcon",
  },
  {
    name: "Neutrally Buoyant Float",
    color: "#F2B705",
    icon: <PermanentWaterSiteIcon />,
    mapIcon: "PermanentWaterIcon",
  },
  {
    name: "Moored Buoy",
    color: "#8C2D04",
    icon: <MooredBuoyIcon />,
    mapIcon: "MooredBuoyIcon",
  },
  {
    name: "ARGO",
    color: "#FFF7AE",
    icon: <MooredBuoyIcon />,
    mapIcon: "MooredBuoyIcon",
  },
  {
    name: "Ship",
    color: "#F2290A",
    icon: <ShipIcon />,
    mapIcon: "ShipIcon",
  },
  {
    name: "Rocket Launch Site",
    color: "#FF1F19",
    icon: <RocketIcon />,
    mapIcon: "RocketIcon",
  },
]

export const flightPathColors = platforms =>
  platforms.map((i, index) => [
    i,
    MOVING_PLATFORMS_COLORS[index] || FALLBACK_COLOR,
  ])

const hex2rgb = hex => hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16))

export const getLineColorAsRGB = index => {
  const color = MOVING_PLATFORMS_COLORS[index]
  if (color === undefined) return hex2rgb(FALLBACK_COLOR)
  // converts from HEX to RGB
  return hex2rgb(color)
}

export const getLineColors = platforms => {
  const colors = flightPathColors(platforms)
  return [
    "match",
    ["get", "platform_name"],
    ...colors.flatMap(i => i),
    FALLBACK_COLOR,
  ]
}

export const getStaticIcons = () => {
  const icons = STATIC_PLATFORMS.map(i => [i.name, i.mapIcon])
  return [
    "match",
    ["get", "platform_name"],
    ...icons.flatMap(i => i),
    "BalloonIcon", // fallback icon
  ]
}

export const getIconColors = () => {
  const colors = STATIC_PLATFORMS.map(i => [i.name, i.color])
  return [
    "match",
    ["get", "platform_name"],
    ...colors.flatMap(i => i),
    "#fff", // fallback color
  ]
}

export const getPlatformIcon = platformName =>
  STATIC_PLATFORMS.find(i => i.name === platformName).mapIcon

export const isPlatformVisible = ({
  platformProperties,
  selectedPlatforms,
  selectedDeployment,
}) => {
  return (
    (selectedDeployment === null ||
      selectedDeployment.longname === platformProperties.deployment) &&
    (selectedPlatforms === null ||
      selectedPlatforms.includes(platformProperties.platform_name))
  )
}
